import React, {useState} from "react";
import {Avatar, Button, Dropdown, Image, Layout, Menu, message, Modal, Space} from "antd";
import logo from '../../assets/img/logo128.png'
import {CaretDownOutlined, DotChartOutlined, UserOutlined, WarningOutlined} from "@ant-design/icons";
import {useNavigate} from "react-router-dom";
import {ApiService} from "../../services/ApiService";

const {Header} = Layout;

const LayoutHeader = ({hideText, user}) => {
    const navigate = useNavigate()
    const [logoutModalVisible, setLogoutModalVisible] = useState(false)

    const handleLogoutClick = () => {
        setLogoutModalVisible(true)
    }

    const handleLogoutCancel = () => {
        setLogoutModalVisible(false)
    }

    const handleLogoutConfirm = () => {
        ApiService.user.logout()
            .onSuccess(() => {
                message.success("用户状态已清除")
                navigate('/', {replace: true})
            })
    }

    const userMenu = (
        <Menu>
            <Menu.Item key="0" onClick={handleLogoutClick}>退出登录</Menu.Item>
        </Menu>
    )

    return (
        <>
            <Header className="header" style={{position: 'fixed', zIndex: 3, width: '100%', padding: '0 20px'}}>
                <Space align={'center'} style={{height: 64, cursor: 'pointer'}}>
                    <Image width={30} height={30} src={logo} preview={false} style={{marginTop: 9}}
                           onClick={e => window.location = '/'}/>
                    <Button ghost onClick={e => {
                        window.open('/bs')
                    }}><DotChartOutlined/>大数据平台</Button>
                </Space>
                <Dropdown overlay={userMenu} trigger={['click']}>
                    <Space style={{float: 'right', cursor: 'pointer'}}>
                        <Avatar shape="square" icon={<UserOutlined/>}/>
                        <span style={{color: '#fff'}}>{user.username}</span>
                        <CaretDownOutlined style={{color: '#fff'}}/>
                    </Space>
                </Dropdown>
            </Header>
            <Modal title={<span><WarningOutlined style={{color: 'orange'}}/> 退出前确认</span>}
                   visible={logoutModalVisible}
                   width={300}
                   okText={"确定"}
                   okButtonProps={{type: 'danger'}}
                   cancelText={"取消"}
                   onOk={handleLogoutConfirm}
                   onCancel={handleLogoutCancel}>
                <p>退出登录将清除当前用户状态。</p>
                <p>确认要退出登录吗？</p>
            </Modal>
        </>

    )
}

export default LayoutHeader